module.exports = __webpack_public_path__ + "static/4-e518d9e5ab8e4ce92b5b1e6702002c5a.jpg";